import { MDBModal, MDBModalBody, MDBModalHeader } from 'mdbreact'
import React, { useState } from 'react'
import EditSingleLegendStats from './EditSingleLegendStats';

function EditLegendStatsListTemplate({player, teamId}) {



    const [show, setShow] = useState(false);

    function toggle() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    return (
        <div className="col-md-4 col-lg-3 col-xl-2">
            <div className="card">
                <img src={player.player_image} alt={player.player_name} />
                <div className="card-body">
                    <p>{player.player_name}</p>
                    <div className="text-muted" style={{fontSize: "0.75rem"}}>
                        <p>Kamper: {player.fixtures}</p>
                        <p>Mål: {player.goals}</p>
                        <p>Assist: {player.assists}</p>
                        <div>
                            <button onClick={() => setShow(true)}>Rediger</button>
                        </div>
                    </div>
                </div>
            </div>
            <MDBModal toggle={toggle} isOpen={show}>
                <MDBModalHeader>
                    Rediger spillerstats for {player.player_name}
                </MDBModalHeader>
                <MDBModalBody>
                    <EditSingleLegendStats player={player} teamId={teamId} />
                </MDBModalBody>
            </MDBModal>
        </div>
    )
}
export default EditLegendStatsListTemplate